import { API_BASE_URL as BASE } from './apiConfig';
import { createAuthedAxios } from '@/lib/authedAxios';

const client = createAuthedAxios({ baseURL: `${BASE}/api` });

// ── 타입 ─────────────────────────────────────────────────────

export interface CustomAlt {
  id: number;
  imageId: number;
  customAltText: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomAltResponse {
  success: boolean;
  data?: CustomAlt;
  message?: string;
}

// ── API ───────────────────────────────────────────────────────

export const customAltApi = {
  /** 커스텀 ALT 생성/수정 (POST /api/my/custom-alt/{imageId}) */
  saveCustomAlt: (imageId: number, customAltText: string) =>
    client.post<CustomAltResponse>(`/my/custom-alt/${imageId}`, { customAltText }),

  /** 커스텀 ALT 조회 (GET /api/my/custom-alt/{imageId}) */
  getCustomAlt: (imageId: number) =>
    client.get<CustomAltResponse>(`/my/custom-alt/${imageId}`),

  /** 커스텀 ALT 삭제 (DELETE /api/my/custom-alt/{imageId}) */
  deleteCustomAlt: (imageId: number) =>
    client.delete<{ success: boolean; message: string }>(`/my/custom-alt/${imageId}`),
};
